module.exports = __webpack_public_path__ + "static/front/img/ship_icon_4.2c4786b2.png";